import {useMutation} from '@apollo/react-hooks';

import type {
    MeetingDeleteInput,
    DeleteMeeting as DeleteMeetingMutation,
    DeleteMeetingVariables as DeleteMeetingMutationVariables,
    GetMeetings as GetMeetingsQuery,
} from 'nutshell-graphql-types';

import DELETE_MEETING from '../mutations/delete-meeting.graphql';
import GET_MEETINGS from '../queries/get-meetings.graphql';

export function useDeleteMeeting(input: {
    entityIds?: string[];
    archived: boolean;
}): (arg1: MeetingDeleteInput) => Promise<any> {
    const [deleteMeeting] = useMutation<DeleteMeetingMutation, DeleteMeetingMutationVariables>(
        DELETE_MEETING
    );

    return (deleteInput: MeetingDeleteInput) => {
        return deleteMeeting({
            variables: {input: deleteInput},
            update: (proxy, mutationResults) => {
                const cacheResult: GetMeetingsQuery | null | undefined = proxy.readQuery({
                    query: GET_MEETINGS,
                    variables: {
                        entityIds: input.entityIds,
                        archived: input.archived,
                    },
                });

                const deletedMeeting =
                    mutationResults &&
                    mutationResults.data &&
                    mutationResults.data.meetingDelete &&
                    mutationResults.data.meetingDelete.meeting;

                if (!deletedMeeting) return;

                if (cacheResult) {
                    proxy.writeQuery({
                        query: GET_MEETINGS,
                        variables: {entityIds: input.entityIds, archived: input.archived},
                        data: {
                            meetings: cacheResult.meetings.filter(
                                (meeting) => meeting.id !== deletedMeeting.id
                            ),
                        },
                    });
                }
            },
        });
    };
}
